// ============================================================================
// FKLoader — loading padrão do sistema: logo DNA Feel King + animação quantum
// (ldrs). Usar em TODO carregamento de página ou de dados.
//
//   <FKLoader fullScreen />        → tela inteira ink (boot, troca de rota)
//   <FKLoader />                   → bloco centralizado em página clara
//   <FKLoader compact />           → versão menor pra seções/cards
//   <FKLoader label="Buscando…" /> → texto opcional embaixo
// ============================================================================

import React from 'react';
import { quantum } from 'ldrs';
import DNALogo from './DNALogo.jsx';

quantum.register();

// Anti-"vulto": o loader nasce invisível e só faz fade-in depois de um
// pequeno delay. Carregamento rápido (<250ms) = ninguém vê loader nenhum;
// carregamento de verdade = ele surge suave em vez de piscar na tela.
// (animation-delay segura a opacidade em 0 até a animação começar)
const fadeIn = (delayMs) => ({
  opacity: 0,
  animation: `fk-loader-in 0.4s ease-out ${delayMs}ms forwards`,
});

function FKLogo({ dark }) {
  return <DNALogo tone={dark ? 'light' : 'dark'} width={150} />;
}

export default function FKLoader({ fullScreen = false, compact = false, dark = false, label = null, className = '' }) {
  if (fullScreen) {
    // Boot: o fundo ink entra na hora (sem flash branco), o conteúdo faz fade
    return (
      <div className="min-h-screen bg-ink flex flex-col items-center justify-center" aria-busy="true" aria-label="Carregando">
        <div className="flex flex-col items-center gap-6" style={fadeIn(150)}>
          <FKLogo dark />
          <l-quantum size="42" speed="1.75" color="#91AACF" />
          {label && <p className="text-cream/60 text-sm font-medium">{label}</p>}
        </div>
      </div>
    );
  }
  if (compact) {
    return (
      <div className={`flex flex-col items-center justify-center gap-3 py-8 ${className}`} style={fadeIn(250)} aria-busy="true" aria-label="Carregando">
        <l-quantum size="30" speed="1.75" color="#41659E" />
        {label && <p className="text-slate-500 text-xs font-medium">{label}</p>}
      </div>
    );
  }
  return (
    <div className={`flex flex-col items-center justify-center gap-5 py-20 ${className}`} style={fadeIn(250)} aria-busy="true" aria-label="Carregando">
      <FKLogo dark={dark} />
      <l-quantum size="42" speed="1.75" color={dark ? '#91AACF' : '#41659E'} />
      {label && <p className={`text-sm font-medium ${dark ? 'text-cream/60' : 'text-slate-500'}`}>{label}</p>}
    </div>
  );
}
